import { CheckoutStep } from "@shared/schema";
import { ROUTES, buildUrl } from "@/lib/navigation";

type OrderFlowState = {
  step?: CheckoutStep;
  orderPickup?: {
    _id?: string;
    orderId?: string;
    storeId?: string;
    status?: string;
  };
  store?: {
    _id?: string;
  } | null;
};

const COMPLETE_STATUSES = new Set([
  "complete",
  "completed",
  "delivered",
  "cancelled",
  "canceled",
  "refunded",
  "order placed",
]);

export function getOrderFlowRoute({
  step,
  orderPickup,
  store,
}: OrderFlowState): string {
  const storeId = orderPickup?.storeId || store?._id || "";
  const orderId = orderPickup?._id || orderPickup?.orderId || "";
  const status = String(orderPickup?.status || "").toLowerCase();

  if (step === "complete" || COMPLETE_STATUSES.has(status)) {
    return ROUTES.STORE_DETAILS;
  }

  if (step === "payment" && storeId && orderId) {
    return buildUrl(ROUTES.PAYMENT, { storeId, orderId });
  }

  if (step === "delivery_details" && storeId && orderId) {
    return buildUrl(ROUTES.DELIVERY_DETAILS, { storeId, orderId });
  }

  if (step === "order_details" && storeId) {
    return buildUrl(ROUTES.ORDER_DETAILS, { storeId });
  }

  return ROUTES.STORE_DETAILS;
}
